import { FC } from 'react';
import { SMPFlex, SMPText } from '@velinsi/smp-widgets-ui';
import { getIconAsBgImage } from '@sportal365/smp-widget-utils';

import { EventParticipantType, ISubscriberInfoFn, StatusType } from '../../../../../../packages/types';
import { Competition, EventContainer } from '../../common';
import { styled } from '../../../../../../packages/theme/stitches.config';
import { formatScoreWithOrdinal } from '../../../utils/formatRankingWithOrdinal';

interface IRacingEventProps {
  dateTime: {
    date: string;
    time: string;
  };
  winnerText: string;
  participants: EventParticipantType[];
  eventLink?: string;
  urlTarget?: string;
  status: StatusType;
  stage: string | null;
  competitionLogo: string;
  topEventsSelected?: boolean;
  displayOdds: boolean;
  handleClick: ISubscriberInfoFn;
  handleEventClick: (event: string) => void;
  id: string;
}

const ParticipantThumb = styled.withConfig({ componentId: 'CyclingEvent', displayName: 'ParticipantThumb' })('div', {
  borderRadius: '$round',
  width: '16px',
  height: '16px',
  backgroundSize: 'cover',
});

const EventText = styled.withConfig({ componentId: 'CyclingEvent', displayName: 'EventText' })('span', {
  margin: '0',
  fontWeight: 400,
  fontVariantNumeric: 'tabular-nums',
  fontFamily: '$sans',
  fontSize: '$2',
  lineHeight: '16px',
  variants: {
    type: {
      stats: {
        color: '$multiSportCommonColor',
        textAlign: 'right',
      },
      team: {
        color: '$multiSportTextColor',
      },
    },
  },
});

const RacingEvent: FC<IRacingEventProps> = ({
  id,
  participants,
  winnerText,
  eventLink,
  urlTarget,
  stage,
  displayOdds,
  handleClick,
  handleEventClick,
}) => {
  return (
    <>
      {stage && <Competition subText={null} name={stage} id={stage} handleClick={handleClick} />}
      {participants.map((participant, index) => (
        <EventContainer key={index} displayOdds={displayOdds}>
          <a target={urlTarget} href={eventLink} style={{ width: '100%', textDecoration: 'none' }} onClick={() => handleEventClick(id)}>
            <div style={{ height: '16px' }}>
              <SMPFlex css={{ width: '100%' }} justify={'spaceBetween'} align={'center'}>
                {participant.isWinner && (
                  <SMPText css={{ color: '$multiSportWinner' }} size={'2'}>
                    {winnerText}
                  </SMPText>
                )}
                {participant.score && !participant.isWinner && (
                  <SMPText css={{ color: '$diffContrastBgColor' }} size={'2'}>
                    {formatScoreWithOrdinal(Number(participant.score))}
                  </SMPText>
                )}
              </SMPFlex>
            </div>
          </a>
          <a target={urlTarget} href={eventLink} style={{ width: '100%', textDecoration: 'none' }} onClick={() => handleEventClick(id)}>
            <SMPFlex>
              <ParticipantThumb style={{ backgroundImage: `url("${getIconAsBgImage('racer-placeholder')}")` }} />
              <SMPText
                css={{ fontSize: '12px', lineHeight: '20px', ml: '$1', mr: '$2', fontWeight: 'bold', color: '$multiSportTextColor' }}
              >
                {participant.name}
              </SMPText>
              <div style={{ width: '20px' }} />
            </SMPFlex>
          </a>
          {participant.duration && (
            <a target={urlTarget} href={eventLink} style={{ width: '100%', textDecoration: 'none' }}>
              <EventText type={'stats'}>{participant.duration}</EventText>
            </a>
          )}
        </EventContainer>
      ))}
    </>
  );
};

export default RacingEvent;
